<template>
  <div class="select-craft">
    <re-dialog
        :visible.sync="show_craft"
        :title="disabled ? '工艺信息' : '选择工艺信息'"
        :width="!disabled ? '1000px' : '900px'"
        custom-class="select-craft-dialog"
    >
      <div :class="{ 'select-craft-box': !disabled, 'craft-box': disabled }">
        <el-menu @select="menuSelect" :unique-opened="true" v-if="!disabled">
          <el-submenu
              :index="k + ''"
              v-for="(i, k) in craft_list"
              :key="i.craft_id"
              :popper-append-to-body="false"
          >
            <template slot="title">
              <span>{{ i.craft_name }}</span>
            </template>
            <el-menu-item
                :index="s + ''"
                v-for="(j, s) in i.craftBeans"
                :key="j.craft_id"
                :class="{ is_active: j.checked }"
            >
              <!-- 工艺选项：缩略图 + 名称 + 价格，整项可点选，选择逻辑仍走 menuSelect -->
              <div class="craft-menu-item">
                <!-- 工艺图片：craft_images 为逗号分隔字符串，取第一张作缩略图；
                     点击可放大预览（多张可切换），@click.stop 避免误触选择 -->
                <div class="craft-menu-item__img" @click.stop>
                  <el-image
                      v-if="splitCraftImages(j.craft_images).length"
                      :src="`${splitCraftImages(j.craft_images)[0]}?x-oss-process=image/quality,q_50`"
                      :preview-src-list="splitCraftImages(j.craft_images)"
                      fit="cover"
                      class="thumb"
                  />
                  <div v-else class="thumb thumb--empty">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </div>
                <!-- 名称 + 价格 -->
                <div class="craft-menu-item__info">
                  <!-- 工艺名称：过长时自动换行，不截断、不撑破布局 -->
                  <div class="name">
                    <span>{{ j.craft_name }}</span>
                    <!-- 默认工艺标记：原蓝色文字改为标签，避免与选中态混淆 -->
                    <span class="craft-tag" v-if="j.basic_color === '#0065A9'">默认</span>
                  </div>
                  <!-- 工艺价格：加粗突出，仅在销售或代客下单时展示 -->
                  <div
                      class="price"
                      v-if="$store.state.is_sales || !is_Empty($store.state.sale_info)"
                  >￥{{ j.craft_price }}</div>
                </div>
                <!-- 选中标记：绿色对勾，直观区分是否已选 -->
                <i class="el-icon-success check" v-if="j.checked"></i>
              </div>
            </el-menu-item>
          </el-submenu>
        </el-menu>

        <div class="right pl20">
          <div v-for="(i, k) in test_info" :key="i.craft_id" class="mb20 bb1">
            <div class="shop-table">
              <!-- 普通的工艺 -->
              <div class="craft-title-box bb1 fr ac jsb">
                <span>{{ i.parent_craft_name }}</span>
                <span class="fz12 ellipsis-1line">{{ i.craft_name }}</span>
              </div>
              <div class="bb1 fr ac jsb craft-title-box">
                <span class="craft-title1">工艺数量</span>
                <input
                    type="number"
                    :min="0.01"
                    :disabled="disabled"
                    v-model="i.craft_count"
                    @input="calculateDisabled = false;craftChange(i, k)"
                />
              </div>
              <div class="fr ac jc" v-if="!disabled">
                <i
                    class="el-icon-error fz30"
                    @click="menuSelect(i.parent_index, [i.parent_index, i.index],k)"
                ></i>
              </div>
            </div>
            <!-- 开孔/气眼工艺 -->
            <div class="craft-item-box" v-if="i.gas_eye_show">
              <div class="craft-box-item">
                <span>距头位置(L2)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.l2"
                      @input="calculateDisabled = true;valueChange(i, k)"
                      @blur="calculateDisabled = false;craftChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>距尾位置(L4)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.l4"
                      @input="calculateDisabled = true;valueChange(i, k)"
                      @blur="calculateDisabled = false;craftChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>

              <div class="craft-box-item">
                <span>气眼间距(L3)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.l3"
                      @input="calculateDisabled = true;valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>距边位置(W2)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.w2"
                  />
                  <span>mm</span>
                </div>
              </div>
            </div>
            <!-- 打孔工艺 -->
            <div class="craft-item-box" v-if="i.punch">
              <div class="craft-box-item">
                <span>距边位置(W4)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.w4"
                      @input="valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>距边位置(W6)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.w6"
                      @input="valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>距接头位置(W5)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.w5"
                      @input="valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>孔间距(W3)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.w3"
                      @input="valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
            </div>
            <!-- 导向条工艺 -->
            <div class="craft-item-box" v-if="i.guide_bar">
              <div class="craft-box-item">
                <span>中心距边(W1)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.w1"
                      @input="valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>导条中心距(C1)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.c1"
                      @input="valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
            </div>
            <!--        铆扣-->
            <div class="craft-item-box" v-if="i.riveted_buckle">
              <div class="craft-box-item">
                <span>距头位置(L2)</span>
                <div class="craft-input-box">
                  <input
                      :disabled="disabled"
                      type="Number"
                      v-model="i.l2"
                      @input="valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>距尾位置(L4)</span>
                <div class="craft-input-box">
                  <input
                      :disabled="disabled"
                      type="Number"
                      v-model="i.l4"
                      @input="valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>铆扣间距(L3)</span>
                <div class="craft-input-box">
                  <input
                      :disabled="disabled"
                      type="Number"
                      v-model="i.l3"
                      @input="valueChange(i, k)"
                  />
                  <span>mm</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>铆扣中心距(L1)</span>
                <div class="craft-input-box">
                  <input
                      :disabled="disabled"
                      type="Number"
                      v-model="i.l1"
                  />
                  <span>mm</span>
                </div>
              </div>
            </div>
            <!-- 挡板工艺 -->
            <div class="craft-item-box" v-if="i.baffle">
              <div class="craft-box-item">
                <span>距头距离(l1)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.l1"
                      @input="valueChange(i, k)"
                  />
                  <span>m</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>挡板宽度(w1)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.w1"
                      @input="valueChange(i, k)"
                  />
                  <span>m</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>挡板间距(l3)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.l3"
                      @input="valueChange(i, k)"
                  />
                  <span>m</span>
                </div>
              </div>
              <div class="craft-box-item">
                <span>距尾距离(l2)</span>
                <div class="craft-input-box">
                  <input
                      type="Number"
                      :disabled="disabled"
                      v-model="i.l2"
                      @input="valueChange(i, k)"
                  />
                  <span>m</span>
                </div>
              </div>
            </div>

            <img
                v-if="i.punch || i.gas_eye_show"
                style="width:100%;height:400px"
                src="https://img.beltdance.com/app/ky_img/craft-examples.png"
            />
            <img
                v-if="i.guide_bar"
                style="width:100%;height:400px"
                src="https://img.beltdance.com/app/ky_img/guide-bar.png"
            />
            <img
                v-if="i.baffle"
                style="width:100%;height:400px"
                src="https://img.beltdance.com/app/ky_img/baffle.png"
            />
          </div>

          <!-- 工艺备注信息 -->
          <el-input
              type="textarea"
              disabled
              resize="none"
              v-model="remark"
              :rows="8"
              placeholder="备注栏不得写标准工艺，如果写了标准工艺不做数"
          ></el-input>

          <div class="fr ac jc pt30" v-show="!disabled">
            <el-button type="primary" @click="confirm">确认选择</el-button>
          </div>
        </div>
      </div>
    </re-dialog>
  </div>
</template>

<script>
let timer = null;

const KEYS = {
  qiyan: 'gas_eye_show',
  kaikong: "punch",
  "guide-bar": "guide_bar",
  baffle: "baffle",
  caixian: "interval",
  "riveted-buckle": "riveted_buckle"
}
// 各工艺类型额外信息字段映射（与现有 if-else 处理范围一致：qiyan/kaikong/guide-bar/baffle）
const CRAFT_EXTRA_CONFIG = {
  qiyan: { fields: ['l2', 'l4', 'w2', 'l3'], boolKey: 'gas_eye_show' },
  kaikong: { fields: ['w4', 'w5', 'w3', 'w6'], boolKey: 'punch' },
  "guide-bar": { fields: ['w1', 'c1'], boolKey: 'guide_bar' },
  baffle: { fields: ['l1', 'w1', 'l3', 'l2'], boolKey: 'baffle' },
};
export default {
  props: {
    show: Boolean,
    is_add: {
      type: Boolean,
      default: false
    },
    select_craft_list: {
      type: Array,
      // 数组类型默认值需用工厂函数返回，避免多个实例共享同一引用
      default: () => []
    },
    craft_remark: String,
    disabled: {
      type: Boolean,
      default: false
    },
    goods_id: {
      type: [String, Number],
    },
    length: {
      type: [String, Number],
    },
    width: {
      type: [String, Number],
    },
  },
  data() {
    return {
      craft_list: [], //工艺列表
      show_craft: false,
      calculateDisabled: false,
      test_info: [],
      remark: "",
      ids: [],
      default_craft_ids: [],
      craft_extra: {
        qiyan: {l2: null, l4: null, l3: null, w2: null, gas_eye_show: true},
        "riveted-buckle": {l2: null, l4: null, l3: null, l1: null, riveted_buckle: true},
        kaikong: {w3: null, w4: null, w5: null, w6: null, punch: true},
        "guide-bar": {w1: null, c1: null, guide_bar: true},
        baffle: {l1: null, w1: null, l2: null, l3: null, baffle: true},
        caixian: {i1: null, interval: true}
      }
    };
  },
  computed: {},
  created() {
    this.show_craft = this.$props.show;
    // this.getGoodsDetail();
  },
  mounted() {
  },
  watch: {
    show(n) {
      this.show_craft = n;
    },
    show_craft(n) {
      this.$emit("update:show", n);
      if (n) {
        this.init();
      }
    },
    craft_remark() {
      this.remark = this.craft_remark;
    },
    goods_id() {
      // this.getGoodsDetail();
    },
  },
  methods: {
    // 解析工艺图片：craft_images 为逗号分隔的字符串，可能包含多张图片，
    // 过滤掉空值后返回图片地址数组，无数据时返回空数组。
    splitCraftImages(images) {
      if (this.is_Empty(images)) return [];
      return String(images).split(",").filter((item) => !this.is_Empty(item));
    },
    //根据客户行业获取工况要求，并添加到备注信息。
    async getIndustryWorkingConditionByIndustry() {
      let res = await this.post("companyInterfaces/v1.0/getCompanyDetail", {});
      res = await this.post("/app/industryWorkingCondition/getIndustryWorkingConditionByIndustry", {industry_id3: res.data.industry_id3});
      if (res.data.length && this.craft_remark.indexOf(res.data[0].working_condition) === -1) {
        this.remark += `  ${res.data[0].working_condition}`
      }
    },
    async init() {
      //如果disabled是true说明是仅展示，不需要请求其他数据。
      if (this.$props.disabled) {
        this.craftListInit();
        return;
      }
      if (this.goods_id) {
        let res = await this.post("goodsInterfaces/v1.0/getGoodsDetail", {
          goods_id: this.goods_id,
        });
        if (res.status === 'ok') {
          this.ids = res.data.craft_ids.split(",");
          this.default_craft_ids = res.data.default_craft_ids.split(",");
        }
      }
      this.getCraftDetailList();
      if (this.$props.is_add) {
        this.getIndustryWorkingConditionByIndustry();
      }
    },
    valueChange(e, k) {
      try {
        if (e.gas_eye_show) {
          if (!this.calculateDisabled) return;
          let num = this.sub(
              this.mul(this.$props.length, 1000),
              this.add(e.l2 || 0, e.l4 || 0)
          );
          //总长度/气眼间距=气眼数量
          num = this.is_Empty(e.l3) ? 0 : this.div(num, e.l3);
          ++num;
          //如果距头距尾都为0，数量减一
          if (this.is_Empty(e.l2) && this.is_Empty(e.l4)) --num;
          e.craft_count = this.mul(Math.floor(num), 2);
          this.test_info.splice(k, 1, e);
        } else if (e.punch) {
          let num = this.sub(
              this.mul(this.width, 1000),
              this.add(e.w4 || 0, e.w6 || 0)
          );
          if (!this.is_Empty(e.w4) || !this.is_Empty(e.w6)) {
            if (!this.is_Empty(e.w4) && !this.is_Empty(e.w6)) {
              num = this.add(this.div(num, e.w3), 1);
            } else {
              num = this.div(num, e.w3);
            }
          } else {
            num = this.sub(this.div(num, e.w3), 1);
          }
          e.craft_count = this.mul(Math.floor(num), 2);
          this.test_info.splice(k, 1, e);
        } else if (e.baffle) {
          // 挡板工艺计算
          if (Number(e.w1) === 0 || Number(e.l3) === 0) {
            return;
          }

          if (!this.is_Empty(this.length)) {
            let num = this.sub(this.mul(this.length, 1000), this.add(e.l1 || 0, e.l2 || 0));
            //计算出挡板数量
            num = this.toDecimal2(this.div(num, e.l3));
            //挡板数量*挡板宽度=所需挡板长度
            num = this.sub(num, e.w1);

            e.craft_count = this.toDecimal2(num);
            this.test_info.splice(k, 1, e);
          }
        } else if (e.riveted_buckle) {
          let {l2, l4, l3} = e;
          if (l2 && l4 && l3) {
            // 长度减去距头距尾
            let num = this.sub(this.mul(this.length, 1000), this.add(l2 || 0, l4 || 0));
            // 长度除去间距得出数量，再乘两边
            num = this.mul(Math.floor(this.div(num, l3)), 2);
            e.craft_count = num
            this.test_info.splice(k, 1, e);
          }
        }
      } catch (e) {
        console.log(e)
      }

    },
    menuSelect(i, indexs, k) {
      //如果存在已经被删除的工艺就不用在往下执行了。
      if (i === null) {
        this.test_info.splice(k, 1);
        return;
      }
      let currentParentCraft = this.craft_list[indexs[0]];
      let obj = currentParentCraft.craftBeans[indexs[1]];

      obj.checked = !obj.checked;
      if (obj.checked) {
        obj.gas_eye_show = false;
        obj.punch = false;
        obj.parent_craft_name = currentParentCraft.craft_name;
        let extra = this.craft_extra[obj.craft];
        if (!this.is_Empty(extra)) {
          obj = {...obj, ...extra};
        }
        if (!obj.punch && !obj.gas_eye_show && !obj.baffle) {
          obj.craft_count = this[obj.side] || 1;
        }

        obj.parent_index = indexs[0];
        obj.index = indexs[1];
        this.test_info.push(obj);
      } else {
        for (let i = 0; i < this.test_info.length; i++) {
          let el = this.test_info[i];
          if (el.craft_id == obj.craft_id) {
            this.test_info.splice(i, 1);
            i--;
          }
        }
      }
      this.craft_list[indexs[0]].craftBeans[indexs[1]] = obj;
    },
    JSONTranslated(str) {
      try {
        let o = str;
        while (typeof o !== 'object') {
          o = JSON.parse(o);
        }
        return o;
      } catch (e) {
        return {}
      }
    },
    //该初始化操作为仅展示。
    craftListInit() {
      let select_list = JSON.parse(JSON.stringify(this.$props.select_craft_list));

      select_list.forEach((el) => {
        el.craft_extra = this.JSONTranslated(el.craft_extra);

        let extra = this.craft_extra[el.craft];
        for (const extraKey in extra) {
          el[extraKey] = el.craft_extra[extraKey];
        }
        if (el.craft) {
          el[KEYS[el.craft]] = true;
        }

      });
      this.test_info = select_list;
    },
    //   获取工艺信息
    getCraftDetailList() {
      this.post("admin/goodsController/v1.0/getCraftDetailList", {}).then(
          (res) => {
            let craft_list = res.data;
            // 删除掉不需要的.
            let array = this.ids.concat(this.default_craft_ids);
            for (let j = 0; j < craft_list.length; j++) {
              let el = craft_list[j];
              if (array.indexOf(el.craft_id.toString()) !== -1) {
                for (let i = 0; i < el.craftBeans.length; i++) {
                  let e = el.craftBeans[i];
                  //删除掉不需要的工艺以及工艺价格为0的。
                  if (array.indexOf(e.craft_id.toString()) === -1) {
                    el.craftBeans.splice(i, 1);
                    i--;
                  }
                }
              } else {
                craft_list.splice(j, 1);
                j--;
              }
            }

            for (let j = 0; j < craft_list.length; j++) {
              let el = craft_list[j];

              // if (this.ids.indexOf(el.craft_id.toString()) != -1) {
              //   for (let i = 0; i < el.craftBeans.length; i++) {
              //     let e = el.craftBeans[i];
              //     e.basic_color = "#0000000";

              //     if (this.ids.indexOf(e.craft_id.toString()) != -1) {
              //       e.basic_color = "#11c188";
              //     }
              //   }
              // }
              if (this.default_craft_ids.indexOf(el.craft_id.toString()) !== -1) {
                for (let i = 0; i < el.craftBeans.length; i++) {
                  let e = el.craftBeans[i];
                  e.basic_color = "#0000000";
                  if (this.default_craft_ids.indexOf(e.craft_id.toString()) !== -1) {
                    e.basic_color = "#0065A9";
                  }
                }
              }
            }

            let test_info = JSON.parse(JSON.stringify(this.$props.select_craft_list));
            for (let i = 0; i < craft_list.length; i++) {
              craft_list[i].craftBeans.forEach((el, k) => {
                el.checked = false;
                test_info.forEach((e) => {
                  e.parent_index = null;
                  e.index = null;
                  if (el.craft_id == e.craft_id) {
                    e.parent_index = i;
                    e.index = k;
                    el.checked = true;
                  }
                  while (typeof e.craft_extra !== 'object' && this.isJSON(e.craft_extra)) {
                    e.craft_extra = JSON.parse(e.craft_extra);
                  }
                  // 根据工艺类型从 craft_extra 中提取字段并设置布尔标记（与现有 if-else 范围一致）
                  const config = CRAFT_EXTRA_CONFIG[e.craft];
                  if (config) {
                    config.fields.forEach(f => { e[f] = e.craft_extra[f]; });
                    e[config.boolKey] = true;
                  }
                });
              });
            }
            this.craft_list = craft_list;
            this.test_info = test_info;
          }
      );
    },
    confirm() {
      // 参数必填工艺(required_params === 1)未填写完整时，记录具体工艺名称用于提示定位
      let required_empty_name = "";
      this.test_info.forEach((el) => {
        el.craft_extra = {};
        if (el.punch) {
          el.craft_extra.w4 = el.w4;
          el.craft_extra.w5 = el.w5;
          el.craft_extra.w6 = el.w6;
          el.craft_extra.w3 = el.w3;
        }
        if (el.gas_eye_show) {
          el.craft_extra.l2 = el.l2;
          el.craft_extra.l4 = el.l4;
          el.craft_extra.w2 = el.w2;
          el.craft_extra.l3 = el.l3;
        }
        if (el.baffle) {
          el.craft_extra.l1 = el.l1;
          el.craft_extra.w1 = el.w1;
          el.craft_extra.l3 = el.l3;
          el.craft_extra.l2 = el.l2;
        }
        if (el.guide_bar) {
          el.craft_extra.w1 = el.w1;
          el.craft_extra.c1 = el.c1;
        }
        // 该工艺参数必填时，额外信息至少要填一项：craft_extra 为空，或所有参数值都为空/为 0，才拦截提交
        if (Number(el.required_params) === 1) {
          const extraValues = Object.values(el.craft_extra);
          if (
            !extraValues.length ||
            extraValues.every((v) => this.is_Empty(v) || Number(v) === 0)
          ) {
            // 只记录第一个未填写的工艺名称
            if (this.is_Empty(required_empty_name))
              required_empty_name = el.craft_name;
          }
        }
      });
      // 存在必填参数未填写(为空或为0)的工艺，拦截提交并提示具体是哪个工艺的额外信息
      if (!this.is_Empty(required_empty_name)) {
        this.$message.warning(`请完善【${required_empty_name}】的额外信息`);
        return;
      }
      this.$emit("update:select_craft_list", JSON.parse(JSON.stringify(this.test_info)));
      this.$emit("update:craft_remark", this.remark);
      this.show_craft = false;
      this.$emit("success");
    },
    craftChange(i, k) {
      if (this.is_Empty(i.gas_eye_show)) return;
      if (this.calculateDisabled) return;
      if (timer != null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        let obj = JSON.parse(JSON.stringify(i));
        if (!this.is_Empty(this.length)) {
          // 计算气眼间距,先用总长度减去距头距尾距离,再除以气眼数量
          let craft_count = this.div(obj.craft_count, 2); //气眼数量除以2,得出单边气眼数量
          let length = this.mul(this.length, 1000); //长度转换为毫米
          let num = this.sub(length, this.add(obj.l2 || 0, obj.l4 || 0));

          --craft_count;
          //如果距头距尾都为0，数量加1
          if (this.is_Empty(obj.l2) && this.is_Empty(obj.l4)) ++craft_count;

          //计算出间距。
          num = this.div(num, craft_count);

          obj.l3 = this.toDecimal2(num);
          this.test_info.splice(k, 1, obj);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
// 弹窗被 append-to-body 挂到 body 下，不在 .select-craft 内部，
// 通过 re-dialog 透传的 custom-class（.select-craft-dialog）定位弹窗本体
.select-craft-dialog {
  input[disabled] {
    background-color: transparent;
  }

  .el-dialog__body {
    padding: 20px 0 !important;
  }

  .craft-title-box {
    display: grid;
    grid-template-columns: 25% 75%;
    // text-align: right;
  }

  .craft-box {
    width: 1000px;

    .right {
      padding: 0 20px;

      .craft-item-box {
        width: 100%;
        display: grid;
        grid-template-columns: 50% 50%;
        margin-bottom: 20px;

        span {
          text-align: center;
        }

        .craft-box-item {
          display: grid;
          grid-template-columns: 35% 65%;
          text-align: right;
          grid-template-rows: 40px;
          line-height: 40px;

          .craft-input-box {
            height: 40px;
            line-height: 40px;
            display: grid;
            grid-template-columns: 80% 20%;
            border-bottom: 1px solid #d4d4d4;

            input {
              height: 90%;
              padding-left: 20px;
            }
          }
        }
      }

      .shop-table {
        .craft-title {
          // padding-right: 20px;
          text-align: right;
        }

        .el-input-number {
          width: 100%;
        }


        width: 100%;
        display: grid;
        grid-template-columns: 46% 43% 5%;
        // grid-template-columns: 15% 35% 15% 25% 10%;
        grid-template-rows: 40px;
        line-height: 40px;
        margin-bottom: 20px;
      }
    }
  }

  .select-craft-box {
    width: 1000px;
    display: grid;
    grid-template-columns: 250px 750px;
    
    .el-menu {
      width: 250px !important;
    }

    // 菜单项样式不依赖 .el-menu 嵌套，避免 submenu 渲染为 popper 时选择器失效
    .el-menu-item {
      display: flex;
      align-items: center;
      white-space: normal !important;
      min-height: 50px !important;
      line-height: 20px;
      height: auto !important;
      padding: 10px 12px !important;
      max-width: 250px !important;
    }

    .is-active {
      background-color: white !important;
      color: black !important;
    }

    // 选中态：绿色高亮边框 + 浅绿底色，避免与蓝底工艺图片撞色
    .is_active {
      background-color: #e8faf0 !important;
      color: #0c3e6a !important;
      box-shadow: inset 0 0 0 2px #07c160;
    }

    // 工艺选项内容：缩略图 + 信息 + 选中标记，横向排列
    // 单独提出来，不依赖 .el-menu 嵌套，避免 submenu 渲染为 popper 时选择器失效
    .craft-menu-item {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;

      // 缩略图
      &__img {
        flex-shrink: 0;
        margin-right: 12px;

        .thumb {
          width: 56px;
          height: 56px;
          border-radius: 8px;
          border: 1px solid #eee;
          overflow: hidden;
          display: block;

          // 无图占位
          &--empty {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #c0c4cc;
            font-size: 24px;
            background: #f5f7fa;
          }
        }
      }

      // 名称 + 价格
      &__info {
        flex: 1;
        min-width: 0;
        text-align: left;

        .name {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          color: #303133;
          font-size: 13px;
          line-height: 1.4;

          // 默认工艺标签
          .craft-tag {
            flex-shrink: 0;
            margin-left: 6px;
            padding: 0 6px;
            color: #1989fa;
            font-size: 12px;
            line-height: 18px;
            background: rgba(25, 137, 250, 0.1);
            border-radius: 4px;
          }
        }

        // 工艺价格：红色加粗突出
        .price {
          margin-top: 4px;
          color: #ee0a24;
          font-size: 14px;
          font-weight: bold;
        }
      }

      // 选中对勾：绿色，在任意背景上清晰
      .check {
        flex-shrink: 0;
        margin-left: 6px;
        color: #07c160;
        font-size: 20px;
      }
    }

    .right {
      padding: 0 20px;

      .shop-table {
        width: 100%;
        display: grid;
        grid-template-columns: 46% 43% 5%;

        grid-template-rows: 40px;
        grid-column-gap: 20px;
        line-height: 40px;
        margin-bottom: 20px;

        .craft-title {
          // padding-right: 20px;
          text-align: right;
        }
      }

      .craft-item-box {
        width: 100%;
        display: grid;
        grid-template-columns: 50% 50%;
        margin-bottom: 20px;

        span {
          text-align: center;
        }

        .craft-box-item {
          display: grid;
          grid-template-columns: 35% 65%;
          text-align: right;
          grid-template-rows: 40px;
          line-height: 40px;

          .craft-input-box {
            height: 40px;
            line-height: 40px;
            display: grid;
            grid-template-columns: 80% 20%;
            border-bottom: 1px solid #d4d4d4;

            input {
              height: 90%;
              padding-left: 20px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/selectcraft.vue